/**
 * Переход «в нужное место» по адресу из пуша: `/?chat=<id>`, `/?section=…`.
 *
 * Чат открывает WorkspaceView, но в момент перехода его может не быть на
 * экране (открыт другой раздел или приложение только запускается). Поэтому
 * id кладётся сюда, а WorkspaceView забирает его при появлении и по событию.
 */

export const OPEN_CHAT_EVENT = 'tw:open-chat';

let pendingChat: string | null = null;

export function requestOpenChat(chatId: string): void {
  pendingChat = chatId;
  window.dispatchEvent(new Event(OPEN_CHAT_EVENT));
}

export function takePendingChat(): string | null {
  const id = pendingChat;
  pendingChat = null;
  return id;
}
